export { default as BtnFilterAfishaTag } from './AfishaTag'
